export class Config {
    static isLogEnabled = false;
}